"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectModelJs = require("@zerobytes/object-model-js");

var _CompanyArea = _interopRequireDefault(require("./CompanyArea"));

var _WorkflowPhase = _interopRequireDefault(require("../shapes/WorkflowPhase"));

var _WorkflowExpiration = _interopRequireDefault(require("../shapes/WorkflowExpiration"));

var _ProcessDocument = _interopRequireDefault(require("../shapes/ProcessDocument"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @type Workflow
 */
var Workflow =
/*#__PURE__*/
function (_ModelBase) {
  _inherits(Workflow, _ModelBase);

  function Workflow() {
    var _this;

    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, Workflow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Workflow).call(this, 'workflow'));
    _this.$fieldConfig = {
      company: {
        type: 'string',
        validate: function validate() {
          return true;
        }
      },
      actionBanner: {
        type: 'string',
        validate: function validate() {
          return true;
        }
      },
      name: {
        type: 'string',
        validate: function validate() {
          return true;
        }
      },
      description: {
        type: 'string',
        validate: function validate() {
          return true;
        }
      },
      security: {
        type: 'string',
        validate: function validate() {
          return true;
        }
      },
      group: {
        type: _objectModelJs.FieldTypes.Object,
        validate: function validate() {
          return true;
        }
      },
      // experation: { type: FieldTypes.ShapedAs(WorkflowExpiration), validate: () => true },
      division: {
        type: _objectModelJs.FieldTypes.IdOf(_CompanyArea["default"]),
        validate: function validate() {
          return true;
        }
      },
      divisionObject: {
        type: _objectModelJs.FieldTypes.Object,
        validate: function validate() {
          return true;
        }
      },
      // experation: { type: FieldTypes.Object, validate: () => true },
      // experation: {
      // 	type: FieldTypes.ShapedAs(WorkflowExpiration),
      // 	defaultValue: {},
      // 	validate: () => true,
      // },
      // experation: {
      // 	type: FieldTypes.ShapedAs(WorkflowExpiration),
      // 	defaultValue: new WorkflowExpiration().$toPlainObject(),
      // 	validate: () => true,
      // },
      document: {
        type: _objectModelJs.FieldTypes.ShapedAs(_ProcessDocument["default"]),
        defaultValue: new _ProcessDocument["default"]().$toPlainObject(),
        validate: function validate() {
          var document = new _ProcessDocument["default"](_this.document);
          return document.$validate();
        }
      },
      experation: {
        type: _objectModelJs.FieldTypes.ShapedAs(_WorkflowExpiration["default"]),
        defaultValue: new _WorkflowExpiration["default"]().$toPlainObject(),
        validate: function validate() {
          var experation = new _WorkflowExpiration["default"](_this.experation);
          return experation.$validate();
        }
      },
      phases: {
        type: _objectModelJs.FieldTypes.ArrayOf(_objectModelJs.FieldTypes.ShapedAs(_WorkflowPhase["default"])),
        defaultValue: [],
        validate: function validate() {
          return true;
        }
      },
      executorGroups: {
        type: _objectModelJs.FieldTypes.ArrayOf('string'),
        defaultValue: [],
        validate: function validate() {
          return true;
        }
      },
      viewGroups: {
        type: _objectModelJs.FieldTypes.ArrayOf('string'),
        defaultValue: [],
        validate: function validate() {
          return true;
        }
      }
    };

    _this.$fill(properties);

    return _this;
  }

  return Workflow;
}(_objectModelJs.ModelBase);

var _default = Workflow;
exports["default"] = _default;